<template>
  <div class="app-main-content">
    <div class="grid-view">
      <div class="main-content" style="padding-bottom:0;">
        <search-item
          ref="searchItem"
          config-module="102102"
          :show-condition="false"
          :show-simple="false"
          :expand-adv="true"
          @query="queryBtnClickHandler"
        >
          <div slot="operations" class="triggers">
            <!--新增-->
            <el-button
              no="Add"
              type="primary"
              @click="addGuaranteeHandler"
            >{{ $t('CargoMsg.Cargo_Add') }}</el-button>

            <!--编辑-->
            <el-button
              v-if="canEdit"
              no="Edit"
              :disabled="!(selectedRow&&selectedRow.approvedState===0)"
              type="primary"
              @click="editGuaranteeHandler"
            >{{ $t('CargoMsg.Cargo_Edit') }}</el-button>

            <!--删除-->
            <el-button
              v-if="canDelete"
              no="Delete"
              :disabled="!(selectedRow&&selectedRow.approvedState===0)"
              type="danger"
              @click="deleteGuaranteeHandler"
            >{{ $t('CargoMsg.Cargo_Delete') }}</el-button>

            <!--批量提交-->
            <el-button
              v-if="canEdit"
              no="BatchCommit"
              type="primary"
              @click="batchSubmitHandler"
            >{{ $t('SeaExport.BatchCommit') }}</el-button>

            <!--批量审核-->
            <el-button
              v-if="canApprove"
              no="BatchAudit"
              type="primary"
              @click="batchAuditHandler"
            >{{ $t('CargoMsg.Cargo_BatchAudit') }}</el-button>

            <!--批量取消审核-->
            <el-button
              v-if="canApprove"
              no="BatchCancelAudit"
              type="primary"
              @click="batchCancelAuditHandler"
            >{{ $t('CargoMsg.Cargo_BatchCancelAudit') }}</el-button>

            <!--批量拒绝-->
            <el-button
              v-if="canReject"
              no="BulkRejection"
              type="primary"
              @click="batchRejectHandler"
            >{{ $t('Information.BulkRejection') }}</el-button>
          </div>
        </search-item>
        <div class="section grid-wrapper">
          <cargo-ag-grid
            config-module="100703"
            :grid-params.sync="gridParams"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            @gridReady="params=>{gridApi=params.api}"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination
            v-show="searchConditions.total>0"
            config-module="100703"
            :total="searchConditions.total"
            :page.sync="searchConditions.pageNum"
            :limit.sync="searchConditions.pageSize"
            @pagination="fetchGuaranteeList"
          />
        </div>
      </div>
      <!-- 详情弹窗 -->
      <guarantee-dialog
        :v-if="guaranteeDialog.visible"
        :visible.sync="guaranteeDialog.visible"
        :context="this"
        :guarantee="guaranteeDialog.guarantee"
        :status.sync="guaranteeDialog.status"
        :locked="guaranteeDialog.locked"
      />
      <reject-dialog
        :v-if="rejectDialog.visible"
        :visible.sync="rejectDialog.visible"
        :reject-call-back="rejectDialog.func"
      />
    </div>
  </div>
</template>

<script>
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import rejectDialog from '@/views/cargo/v0/Information/components/guarantee/rejectDialog'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import * as AdvancedSearchConsts from '@/class/cargo/model/utils/AdvancedSearchConsts'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import CommonState from '@/class/cargo/model/parameters/CommonState'
import { cacheName, cache } from '@/utils/cacheManager'
import { getLoading } from '@/utils/utilBaseElement'
import * as ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import GuaranteeDialog from './components/guarantee/guaranteeDialog'
import { advancedQuery, batchDeleteGuarantee, batchUpdateState } from '@/api/guarantee'
import { deleteFile, getFileList, getFileListByMultiParam } from '@/api/storage'

export default {
  name: 'Guarantee',
  components: { cargoAdvanceSelect, searchItem, rejectDialog, GuaranteeDialog },
  data() {
    return {
      gridApi: null,
      selectedRow: null,
      selectedDataList: [],
      loading: false,
      searchItemAutoInit: false,
      selectTypeNames: TYPE_NAMES,
      allByRole: false, // 查看所有
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        onSortChanged: (event) => {
          if (event && event.api && event.api.rowRenderer) {
            const rowComps = event.api.rowRenderer.rowCompsByIndex
            if (!rowComps) return
            const currentSortJobs = []
            for (const key in rowComps) {
              if (!rowComps[key].rowNode || !rowComps[key].rowNode.data) continue
              currentSortJobs.push(rowComps[key].rowNode.data)
            }
            this.rowData = currentSortJobs
          }
        },
        onRowClicked: this.rowClickedHandler,
        onRowDoubleClicked: (e) => {
          this.selectedRow = e.data
          this.editGuaranteeHandler()
        },
        // 行勾选事件
        onRowSelected: this.onRowSelected
      },
      rowData: [],
      columnDefs: [
        {
          headerName: '', width: 30, checkboxSelection: true,
          suppressSorting: true, suppressMenu: true, suppressSizeToFit: true, suppressResize: true,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AuthorizedClient'),
          field: 'customerIdStr',
          colId: 'customerIdStr',
          width: 200,
          cellRenderer: params => {
            return ColumnUtils.resolveMultipleColumnLabelByCustom(ColumnUtils.getBasicDataCacheList(TYPE_NAMES.basic_data_Company), 'cmpIdx', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ApplicableBranch'),
          field: 'branchIdStr',
          colId: 'branchIdStr',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.resolveMultipleColumnLabelByCustom(ColumnUtils.getBasicDataCacheList(TYPE_NAMES.basic_data_Office_All), 'officeId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BusinessType'),
          field: 'lobStr',
          colId: 'lobStr',
          width: 150,
          cellRenderer: params => {
            return ColumnUtils.resolveMultipleColumnLabelByCustom([...SystemConstants.LOBS], 'code', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_FLCLType'),
          field: 'containerLoadTypeStr',
          colId: 'containerLoadTypeStr',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveMultipleColumnLabelByCustom([...ChargeUtils.CARGO_TYPE_SE], 'code', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_TypeOfGoods'),
          field: 'cargoTypeStr',
          colId: 'cargoTypeStr',
          width: 100,
          cellRenderer: params => {
            return ColumnUtils.resolveMultipleColumnLabelByCustom(ColumnUtils.getBasicDataCacheList(TYPE_NAMES.basic_data_CargoType), 'code', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CreatedBy'),
          field: 'createdBy',
          colId: 'createdBy',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_EntryDate'),
          field: 'dateCreated',
          colId: 'dateCreated',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Auditor'),
          field: 'approvedBy',
          colId: 'approvedBy',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_ReviewTime'),
          field: 'dateApproved',
          colId: 'dateApproved',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_AuditStatus'),
          field: 'approvedState',
          colId: 'approvedState',
          width: 120,
          cellRenderer: (params) => {
            return this.approvedStateLabFun(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_GuaranteeType'),
          field: 'guaranteeType',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnByGuaranteeType(params.value)
          }
        },
        {
          headerName: this.$t('SystemMaintenance.EffectiveTime'),
          field: 'effectiveDate',
          colId: 'effectiveDate',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SystemMaintenance.ExpirationTime'),
          field: 'expiryDate',
          colId: 'expiryDate',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_GuaranteeName'),
          field: 'guaranteeName',
          colId: 'guaranteeName',
          width: 120
        }
      ],
      searchConditions: {
        guaranteeType: '',
        guaranteeName: '',
        pageNum: 1,
        pageSize: 30,
        total: 0,
        branchId: null
      },
      guaranteeTypes: [],
      lobArray: [],
      containerTypes: [],
      approvedState: [
        new CommonState('', '所有', 'ALL'),
        new CommonState('0', '未提交', 'Not Submitted'),
        new CommonState('1', '已提交', 'Submitted'),
        new CommonState('2', '已审核', 'Verified')
      ],
      guaranteeDialog: {
        visible: false,
        status: 'add',
        locked: false,
        guarantee: null
      },
      rejectDialog: {
        visible: false,
        func: null
      }
    }
  },
  computed: {
    url() {
      return URL
    },
    canEdit() {
      return this.$checkPermission(['button_FMGuarantee_edit'])
    },
    canReject() {
      return this.$checkPermission(['button_FMGuarantee_reject'])
    },
    canApprove() {
      return this.$checkPermission(['button_FMGuarantee_approve'])
    },
    canDelete() {
      return this.$checkPermission(['button_FMGuarantee_delete'])
    },
    pleaseSelectChangeGuarantee() {
      return this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_Guarantee')
    },
    officeId() {
      return this.$store.getters.currentOfficeId
    }
  },
  watch: {
    officeId: {
      async handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          await this.fetchGuaranteeList()
        }
      }
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.lobArray.push(new CommonState('', '所有', 'ALL'))
    this.lobArray.push(...SystemConstants.FBA_IE_LOBS)
    this.guaranteeTypes.push(...SystemConstants.GUARANTEE_TYPES)
    this.containerTypes.push(...ChargeUtils.CARGO_TYPE_SE)
    // 初始化列表
    await this.fetchGuaranteeList()
  },
  methods: {
    queryBtnClickHandler(conditionsMap) {
      this.searchConditionsReset()
      // 快捷查询
      if (conditionsMap.simpleTriggerMode) {
        const value = conditionsMap.conditions
        conditionsMap.conditions = []
        conditionsMap.conditions.push(new AdvancedSearchOption('FIELD_TEXT', 'name', value, AdvancedSearchConsts.OPERATOR_LIKE.code).formatObj2Json())
      }
      for (const condition of conditionsMap.conditions) {
        if (condition.value === null || condition.value === undefined || condition.value === '') continue
        this.searchConditions[condition.fieldName] = condition.value
      }
      this.fetchGuaranteeList()
    },
    // 获取列表
    async fetchGuaranteeList() {
      const self = this
      const params = { ...this.searchConditions }
      params.branchId = this.$store.getters.currentOfficeId
      const loading = getLoading()
      await advancedQuery(params).then(res => {
        self.rowData = res.data.list
        this.searchConditions.pageNum = res.data.pageNum
        this.searchConditions.pageSize = res.data.pageSize
        this.searchConditions.total = Number(res.data.total)
        this.selectedDataList = []
      }).catch(e => {
        loading.close()
      }).finally(e => {
        loading.close()
      })
    },
    /**
     * 新增保函
     */
    addGuaranteeHandler() {
      this.guaranteeDialog.guarantee = null
      this.guaranteeDialog.status = 'add'
      this.guaranteeDialog.locked = false
      this.guaranteeDialog.visible = true
    },
    /**
     * 编辑保函
     */
    editGuaranteeHandler() {
      this.loadDetail('edit')
    },
    rowClickedHandler(params) {
      this.selectedRow = params.data
    },
    onRowSelected(event) {
      if (!event || !event.data) return
      if (event.node.isSelected()) {
        this.selectedDataList.push(event.data)
      } else {
        this.selectedDataList = this.gridApi.getSelectedRows()
      }
      this.onRowClicked(event)
    },
    onRowClicked(event) {
      if (!event || !event.data) return
      this.selectedRow = null
      const node = event.data
      if (node.uuid) {
        this.selectedRow = node
      }
    },
    // 删除
    async deleteGuaranteeHandler() {
      const currentRow = this.selectedRow
      if (!currentRow) {
        this.$message.error(this.pleaseSelectChangeGuarantee)
        return
      }
      const self = this
      await this.$confirm(this.$t('Information.DoWantToDelete0', [currentRow.guaranteeName]), this.$t('common.tips.confirm'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      })
      const loading = getLoading()
      try {
        const xmlParam = '<RequestObject><data><extendMetaData><entry><key>guaranteeUuid</key><value>' + this.uuid + '</value></entry></extendMetaData></data></RequestObject>'
        await getFileList(xmlParam).then(res => {
          if (res?.data?.fileId) {
            // 删除文件
            deleteFile(res.data.fileId).then(res => {})
          }
        })

        await batchDeleteGuarantee([currentRow.uuid]).then(res => {
          this.$message.success(this.$t('common.tips.deleteSuccess'))
          self.fetchGuaranteeList()
        })
      } catch (error) {
      } finally {
        loading.close()
      }
    },
    // 提交 按钮事件
    async batchSubmitHandler() {
      // 1. 参数校验
      const rows = this.selectedDataList
      if (!rows?.length) {
        this.$message.error(this.$t('Information.PleaseSelectData'))
        return
      }

      // 2. 检查审核状态
      if (rows.some(p => p.approvedState !== 0)) {
        this.$message.error(this.$t('Information.OnlyGuaranteeWithAuditUnreviewed'))
        return
      }

      const loading = getLoading()
      try {
        // 3. 获取所有UUID
        const uuids = rows.map(row => row.uuid)

        // 4. 构建文件查询参数
        const xmlParamList = uuids.map(uuid => `<RequestObject><data><extendMetaData><entry><key>guaranteeUuid</key><value>${uuid}</value></entry></extendMetaData></data></RequestObject>`)

        // 5. 检查文件上传状态
        const fileRes = await getFileListByMultiParam(xmlParamList)
        if (!fileRes?.data?.length) {
          this.$message.error(this.$t('Information.GuaranteeFileIsNull'))
          return
        }

        // 6. 验证每个保函的文件
        const noFileGuarantees = []
        for (const row of rows) {
          const hasFile = fileRes.data.some(file => file.extendMetaData.guaranteeUuid === row.uuid)
          if (!hasFile) {
            noFileGuarantees.push(row.guaranteeName)
          }
        }

        if (noFileGuarantees.length > 0) {
          this.$message.error(this.$t('Information.SelectGuaranteeFileIsNull', [noFileGuarantees.join('、')]))
          return
        }

        // 7. 更新状态
        await batchUpdateState(uuids, { type: 1 })
        this.$message.success(this.$t('Message.CommitSuccessfully'))

        // 8. 刷新列表
        await this.fetchGuaranteeList()
      } catch (error) {
        this.$message.error(this.$t('CargoMsg.Cargo_OperationFailed'))
      } finally {
        loading.close()
      }
    },
    // 审核 按钮事件
    async batchAuditHandler() {
      const rows = this.selectedDataList
      if (!rows || rows.length === 0) {
        this.$message.error(this.$t('Information.PleaseSelectData'))
        return
      }
      const index = rows.findIndex(p => p.approvedState !== 1)
      if (index !== -1) {
        this.$message.error(this.$t('Information.OnlyGuaranteeWithAuditSubmitted'))
        return
      }
      const uuids = []
      for (const r of rows) {
        uuids.push(r.uuid)
      }
      const loading = getLoading()
      try {
        await batchUpdateState(uuids, { type: 2 })
        this.$message.success(this.$t('Message.AuditSuccessfully'))
        await this.fetchGuaranteeList()
      } finally {
        loading.close()
      }
    },
    async batchCancelAuditHandler() {
      const rows = this.selectedDataList
      if (!rows || rows.length === 0) {
        this.$message.error(this.$t('Information.PleaseSelectData'))
        return
      }
      const index = rows.findIndex(p => p.approvedState !== 2)
      if (index !== -1) {
        this.$message.error(this.$t('Information.OnlyGuaranteeWithAuditReviewed'))
        return
      }
      const uuids = []
      for (const r of rows) {
        uuids.push(r.uuid)
      }
      await this.$confirm(this.$t('CargoMsg.Cargo_SureToCancelVerification'), this.$t('CargoMsg.Cargo_Tips'), { type: 'warning', closeOnClickModal: false })
      const loading = getLoading()
      try {
        await batchUpdateState(uuids, { type: 1 })
        this.$message.success(this.$t('CargoMsg.Cargo_VerificationCancelled'))
        await this.fetchGuaranteeList()
      } finally {
        loading.close()
      }
    },
    // 拒绝 按钮事件
    async batchRejectHandler() {
      const rows = this.selectedDataList
      if (!rows || rows.length === 0) {
        this.$message.error('请勾选数据。')
        return
      }
      const index = rows.findIndex(p => p.approvedState !== 1)
      if (index !== -1) {
        this.$message.error(this.$t('Information.OnlyGuaranteeWithAuditSubmitted'))
        return
      }
      this.rejectDialog.func = this.rejectFunc
      this.rejectDialog.visible = true
    },
    async rejectFunc(reason) {
      if (!reason) {
        this.$message.warning(this.$t('CargoMsg.Cargo_ReasonNotEntered'))
        return false
      }
      await this.$confirm(this.$t('CargoMsg.Cargo_SureToRejectIt'), this.$t('CargoMsg.Cargo_Tips'), { type: 'warning', closeOnClickModal: false })
      const rows = this.selectedDataList
      const uuids = []
      for (const r of rows) {
        uuids.push(r.uuid)
      }
      const loading = getLoading()
      try {
        await batchUpdateState(uuids, { type: 0, reason: reason })
        this.$message.success(this.$t('CargoMsg.Cargo_Denied'))
        await this.fetchGuaranteeList()
      } finally {
        loading.close()
      }
      return true
    },
    /**
     * 加载详情并跳转维护页
     * @param status 'edit': 编辑操作弹窗
     */
    loadDetail(status) {
      const currentRow = this.selectedRow || null
      if (!currentRow) {
        this.$message.error(this.$t('common.tips.hasOneAtleast'))
        return
      }
      // 已审核/已提交不能编辑 0-未提交 1-已提交 2-已审核
      if ((currentRow.approvedState >= 1) || !this.canEdit) {
        this.guaranteeDialog.locked = true
      } else {
        this.guaranteeDialog.locked = false
      }
      this.guaranteeDialog.status = status
      this.guaranteeDialog.guarantee = currentRow
      this.guaranteeDialog.visible = true
    },
    // 审核状态
    approvedStateLabFun(value) {
      if (value === 0) {
        // 未审核
        return this.$t('CargoMsg.Cargo_Uncommitted')
      }
      if (value === 1) {
        // 已提交
        return this.$t('CargoMsg.Cargo_Submitted')
      }
      if (value === 2) {
        // 已审核
        return this.$t('CargoMsg.Cargo_Approved')
      }
      // 状态未知
      return this.$t('CargoMsg.Cargo_UnKnownStatus')
    },
    searchConditionsReset() {
      this.searchConditions = {
        uuid: '',
        approvedState: null,
        approvedBy: null,
        createdBy: null,
        dateApproved: '',
        guaranteeType: '',
        guaranteeName: '',
        effectiveDate: '',
        pageNum: 1,
        pageSize: 30,
        total: 0,
        branchId: null
      }
    }
  }
}
</script>

<style lang="scss">
.cost-plan {
  .el-dialog__body {
    padding: 10px 0 0 0 !important;
  }
}
</style>
